import React from "react"
import { useLocation, NavLink } from "react-router-dom"
import Breadcrumbs from "@mui/material/Breadcrumbs"
import Typography from "@mui/material/Typography"
import { IconRoute } from "../../../utils/Icons"
import { entityTraducLibrary } from "../../../utils/BreadcrumbsLibrary"
import { useStyleBreadcrumbs } from "./useStyleBreadcrumbs"

export default function BreadcrumbsComponent({ name }) {
  const location = useLocation()
  const classes = useStyleBreadcrumbs()

  const pathnames = location.pathname.split("/").filter((x) => x)

  const nonClickableSegments = ["detalleCliente"]

  if (pathnames.length === 0) {
    return null
  }

  return (
    <div className={classes.breadcrumbsStyle}>
      <Breadcrumbs aria-label="breadcrumb">
        <NavLink style={{ textDecoration: "none" }} to="/">
          <div className={classes.linkStyle}>
            {IconRoute("home")}
            <Typography className={classes.typography}>Inicio</Typography>
          </div>
        </NavLink>

        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1
          const isNonClickableSegment = nonClickableSegments.includes(value)

          const isClickable = !isLast && !isNonClickableSegment

          const to = `/${pathnames.slice(0, index + 1).join("/")}`

          const breadcrumbName = isLast
            ? name || entityTraducLibrary(value)
            : entityTraducLibrary(value)

          return isClickable ? (
            <NavLink style={{ textDecoration: "none" }} to={to} key={to}>
              <div className={classes.linkStyle}>
                {IconRoute(value)}
                <Typography className={classes.typography}>
                  {entityTraducLibrary(value)}
                </Typography>
              </div>
            </NavLink>
          ) : (
            <Typography
              style={{ fontWeight: isLast ? 700 : 400 }}
              color="text.primary"
              key={to}
            >
              {breadcrumbName}
            </Typography>
          )
        })}
      </Breadcrumbs>
    </div>
  )
}
